import { createContext } from "react";

let DataContext = createContext({});

export default DataContext;
